function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useMemo } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { uniq } from 'lodash';
import { hideModal } from '../../../../redux/actions';
import text from '../../../../text';
import Icon from '../../../icon/Icon';
import { Button } from '../../../button';
export var MP_UPDATE_SHAPES_MODAL = 'MP_UPDATE_SHAPES_MODAL';
export default function MpUpdateShapesModal(param) {
    var onOk = param.onOk, show = param.show, _param_associatedAddOns = param.associatedAddOns, associatedAddOns = _param_associatedAddOns === void 0 ? [] : _param_associatedAddOns, _param_isNonTripodTarget = param.isNonTripodTarget, isNonTripodTarget = _param_isNonTripodTarget === void 0 ? false : _param_isNonTripodTarget, _param_removeFromCart = param.removeFromCart, removeFromCart = _param_removeFromCart === void 0 ? false : _param_removeFromCart, _param_toDraft = param.toDraft, toDraft = _param_toDraft === void 0 ? false : _param_toDraft;
    var dispatch = useDispatch();
    var handleHide = function() {
        return dispatch(hideModal(MP_UPDATE_SHAPES_MODAL));
    };
    var handleOk = function() {
        onOk();
        handleHide();
    };
    var associatedAddOnDisplayNames = uniq(_to_consumable_array(associatedAddOns.map(function(param) {
        var display_name = param.display_name;
        return display_name;
    }))).join(', ');
    var dialogHeader = useMemo(function() {
        if (!removeFromCart && !toDraft) {
            return text('updateShapesWarning');
        }
        if (removeFromCart) {
            return text('removeFromCartWarning');
        }
        if (toDraft) {
            return text('toDraftWarning');
        }
    }, [
        removeFromCart,
        toDraft
    ]);
    return /*#__PURE__*/ React.createElement(Modal, {
        centered: true,
        className: "UpdateShapeModal",
        onHide: handleHide,
        show: show
    }, /*#__PURE__*/ React.createElement(Modal.Header, {
        className: "centered",
        closeButton: true
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: "circled-exclamation"
    })), /*#__PURE__*/ React.createElement(Modal.Body, {
        className: "centered"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "mb-4"
    }, dialogHeader), associatedAddOnDisplayNames ? /*#__PURE__*/ React.createElement("p", {
        className: "mb-4 font-16 font-weight-bold"
    }, text('updateShapesWarningAddOns', {
        addOns: associatedAddOnDisplayNames,
        caption: isNonTripodTarget || removeFromCart ? 'will be deleted' : 'will also be updated'
    })) : null, /*#__PURE__*/ React.createElement("p", {
        className: "m-0"
    }, text('updateShapesMessage'))), /*#__PURE__*/ React.createElement(Modal.Footer, {
        className: "flex-column justify-content-center"
    }, /*#__PURE__*/ React.createElement(Button, {
        onClick: handleOk,
        autoFocus: true
    }, text(removeFromCart ? 'yesRemove' : 'yesChangeShapeType')), /*#__PURE__*/ React.createElement(Button, {
        onClick: handleHide,
        variant: "link"
    }, text('noCancel'))));
}
